import {
  Component,
  Input,
  ContentChild,
  ViewChild,
  ElementRef,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core'
import * as lodash from 'lodash'
import { SelectItemLabelDirective, SelectOptionItemDirective } from './form-select.directive'
import { FormFieldComponent } from '../form-field/form-field.component'
import { NgSelectComponent } from '@ng-select/ng-select'
import { UntypedFormControl } from '@angular/forms'
import { takeUntil } from 'rxjs/operators'

// Same as ng-select's CompareWithFn, which its public API does not export.
type CompareWithFn = (a: any, b: any) => boolean

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['../form-field-common.scss', './form-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormSelectComponent extends FormFieldComponent {
  @Input() items: any[]
  @Input() bindLabel: string
  @Input() bindValue: string
  @Input() searchable = true
  @Input() searchPlaceholder = $localize`Search...`
  @Input() appendTo = 'body'
  @Input() clearable = false
  @Input() loading = false
  @Input() compareWith: CompareWithFn = lodash.isEqual
  @Input() searchFunc: (term: string, item: any) => boolean

  @ViewChild('select', { static: true }) selectComponent: NgSelectComponent
  @ViewChild('customSearchInput') customSearchInput: ElementRef

  @Output() search = new EventEmitter<string>()

  @ContentChild(SelectOptionItemDirective) selectOptionItem: SelectOptionItemDirective
  @ContentChild(SelectItemLabelDirective) selectItemLabel: SelectItemLabelDirective

  searchCtrl = new UntypedFormControl()

  ngOnInit(): void {
    super.ngOnInit()

    this.searchCtrl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((term) => {
      this.selectComponent.filter(term)
    })
  }

  onSearch({ term }: { term: string }) {
    this.search.emit(term)
  }

  onFocus() {
    setTimeout(() => {
      if (this.customSearchInput) {
        this.customSearchInput.nativeElement.focus()
        this.customSearchInput.nativeElement.select()
      }
    }, 100)
  }

  onClearSearch() {
    this.searchCtrl.reset()
  }

  onSelectDropdownOpen() {
    this.focused = true
    this.onFocus()
  }

  onSelectDropdownClose() {
    this.focused = false
  }

  getItemLabel(item): string {
    return this.bindLabel ? lodash.get(item, this.bindLabel) : lodash.toString(item)
  }
}
